export class UserProgress {
    id: number;
    userId: number;
    puntiTotali: number;
    livello: number;
    badge: string[];
    corsiCompletati: number[];
    streak: number;
    
    constructor() {
        this.id = 0;
        this.userId = 0;
        this.puntiTotali = 0;
        this.livello = 1;
        this.badge = [];
        this.corsiCompletati = [];
        this.streak = 0;
    }
}